import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hook'
import { colors } from '../../ui/colors'
import { EmailIcon } from '../../ui/icons/emailIcon'
import { InputComponent } from '../../ui/molecules/input'
import { ErrorPopup } from '../../ui/organisms/errorPopup'
import { FormRow } from '../../ui/organisms/formRow/formRow'
import { HeadingComponent } from '../../ui/organisms/heading'
import { HeadingSize } from '../../ui/organisms/heading/dto'
import { SuccessPopup } from '../../ui/organisms/successPopup'
import { findCustomerById, setEditCustomerBusinessName, setEditCustomerCertifiedEmail, setEditCustomerEmail, setEditCustomerIp, setEditCustomerMarkupRate, setEditCustomerMinQuota, setEditCustomerName, setEditCustomerNamespace, setEditCustomerSdi, setEditCustomerStatus, setEditCustomerSurname, setEditCustomerVat } from './slice'

export function Registry() {

    const customerState = useAppSelector(state => state.customer)
    const dispatch = useAppDispatch()
    const [namespaces, setNamespaces] = useState([''])

    const timestamp = customerState.findCustomerByIdResponse ? customerState.findCustomerByIdResponse.stripe_timestamp : 0

    useEffect(() => {
        if (customerState.findCustomerByIdResponse) {
            const customer = customerState.findCustomerByIdResponse
            dispatch(setEditCustomerName(customer?.name))
            dispatch(setEditCustomerSurname(customer?.surname))
            dispatch(setEditCustomerMarkupRate(customer?.markup_rate))
            dispatch(setEditCustomerMinQuota(customer?.min_quota))
            dispatch(setEditCustomerCertifiedEmail(customer.certified_mail))
            dispatch(setEditCustomerBusinessName(customer.business_name))
            dispatch(setEditCustomerEmail(customer.email))
            setNamespaces(typeof customer.namespace_k8s === 'string' ? [customer.namespace_k8s] : customer.namespace_k8s)
            dispatch(setEditCustomerVat(customer.vat))
            dispatch(setEditCustomerIp(customer.stripe_ip_address))
            dispatch(setEditCustomerSdi(customer.sdi))
        }
    }, [customerState.findCustomerByIdResponse])

    useEffect(() => {
        dispatch(setEditCustomerNamespace(namespaces.filter(elem => elem.trim())))
    }, [namespaces])

    useEffect(() => {
        if (customerState.editCustomerStatus === 'successfully') {
            dispatch(findCustomerById(customerState.findCustomerByIdResponse!.id))
        }
    }, [customerState.editCustomerStatus])

    return (
        <div className=' flex flex-col gap-5'>
            <SuccessPopup message="Modifiche applicate con successo!" active={customerState.editCustomerStatus === 'successfully'} close={() => dispatch(setEditCustomerStatus('idle'))} />
            <ErrorPopup message="La modifica è fallita!" active={customerState.editCustomerStatus === 'failed'} close={() => dispatch(setEditCustomerStatus('idle'))} />
            <HeadingComponent
                label={"Anagrafica"}
                buttons={[

                ]}
                size={HeadingSize.MD}
            />
            <FormRow
                label="Ragione sociale"
                children={[
                    <InputComponent
                        key={"edit-customer-businessName"}
                        type={"text"}
                        placeholder="Ragione sociale"
                        value={customerState.editCustomerRequest.business_name}
                        onChangeText={(value) => {
                            dispatch(setEditCustomerBusinessName(value))
                        }}
                    />
                ]}
            />
            <FormRow
                label="Nome e Cognome"
                children={[
                    <>
                        <InputComponent
                            key={"edit-customer-name"}
                            type={"text"}
                            placeholder="Nome"
                            value={customerState.editCustomerRequest.name}
                            onChangeText={(value) => {
                                dispatch(setEditCustomerName(value))
                            }}
                        />
                        <InputComponent
                            key={"edit-customer-commercial-surname"}
                            type={"text"}
                            placeholder="Cognome"
                            value={customerState.editCustomerRequest.surname}
                            onChangeText={(value) => {
                                dispatch(setEditCustomerSurname(value))
                            }}
                        />
                    </>
                ]}
            />
            <FormRow
                label="Email"
                children={[
                    <InputComponent
                        key={"edit-customer-email"}
                        type={"text"}
                        placeholder="Email"
                        startIcon={<EmailIcon size={"20"} color={colors.neutral[400]} />}
                        value={customerState.editCustomerRequest.email}
                        onChangeText={(value) => {
                            dispatch(setEditCustomerEmail(value))
                        }}
                    />
                ]}
            />
            <FormRow
                label="P.IVA"
                children={[
                    <InputComponent
                        key={"edit-customer-iva"}
                        type={"text"}
                        placeholder="P.IVA"
                        value={customerState.editCustomerRequest.vat}
                        onChangeText={(value) => {
                            dispatch(setEditCustomerVat(value))
                        }}
                    />
                ]}
            />
            <FormRow
                label="Cod. SDI"
                children={[
                    <InputComponent
                        key={"edit-customer-sdi"}
                        type={"text"}
                        placeholder="Cod. SDI"
                        value={customerState.editCustomerRequest.sdi}
                        onChangeText={(value) => dispatch(setEditCustomerSdi(value))}
                    />,
                ]}
            />
            <FormRow
                label="PEC"
                children={[
                    <InputComponent
                        key={"edit-customer-pec"}
                        type={"text"}
                        placeholder="PEC"
                        value={customerState.editCustomerRequest.certified_mail}
                        onChangeText={(value) => dispatch(setEditCustomerCertifiedEmail(value))}
                    />,
                ]}
            />
            <div className=' pt-8 mt-3 border-t gap-5 flex flex-col w-full'>
                <div className=' flex flex-col gap-1 items-end w-full'>
                    <div className='gap-5 flex flex-col w-full'>
                        {namespaces.map((item, index) =>
                            <FormRow
                                label={index === 0 ? "Namespace k8s" : ""}
                                children={[
                                    <InputComponent
                                        key={"edit-customer-namespace"}
                                        type={"text"}
                                        placeholder="Namespace k8s"
                                        value={item}
                                        onChangeText={(value) => {
                                            setNamespaces(prev => {
                                                const updated = [...prev];
                                                updated[index] = value;
                                                return updated;
                                            });
                                        }}
                                    />
                                ]}
                            />)
                        }
                    </div>
                    <span onClick={() => setNamespaces((prev) => [...prev, ''])} className=" text-[#6237fb] text-text-sm hover:opacity-80 cursor-pointer">+ Aggiungi Namespace</span>
                </div>
                <FormRow
                    label="Tasso di maggiorazione"
                    children={[
                        <InputComponent
                            key={"edit-customer-tdm"}
                            type={"text"}
                            startIcon={<div className=" text-neutral-400 text-text-sm">%</div>}
                            placeholder="Tasso di maggiorazione"
                            value={customerState.editCustomerRequest.markup_rate}
                            onChangeText={(value) => dispatch(setEditCustomerMarkupRate(Number(value)))}
                        />,
                    ]}
                />
                <FormRow
                    label="Quota minima (prezzo i.e.)"
                    children={[
                        <InputComponent
                            key={"edit-customer-min_quota"}
                            type={"text"}
                            placeholder="Quota minima"
                            value={customerState.editCustomerRequest.min_quota}
                            onChangeText={(value) => dispatch(setEditCustomerMinQuota(Number(value)))}
                        />,
                    ]}
                />
            </div>
            <div className=' pt-8 mt-3 border-t gap-5 flex flex-col '>
                <FormRow label={'IP consenso (vedi Stripe)'} children={[
                    <InputComponent
                        key={"edit-customer-ip"}
                        type={"text"}
                        placeholder="IP consenso"
                        value={customerState.editCustomerRequest.stripe_ip_address}
                        onChangeText={(value) => dispatch(setEditCustomerIp(value))}
                    />,
                ]} />
                <FormRow label={'Consensi'} children={[
                    <div className=' flex gap-2 items-center'>
                        <input checked={customerState.findCustomerByIdResponse?.terms_accepted} disabled title='terms' type='checkbox' />
                        <span className=' text-text-sm text-neutral-600'>Termini e Condizioni</span>
                    </div>,
                    <div className=' flex gap-2 items-center'>
                        <input checked={customerState.findCustomerByIdResponse?.clauses_accepted} disabled title='terms' type='checkbox' />
                        <span className=' text-text-sm text-neutral-600'>Informativa sulla privacy</span>
                    </div>,
                    <div className={clsx('gap-1 flex items-center', {
                        'hidden': timestamp === 0
                    })}>
                        <span className=' text-neutral-600 text-text-sm'>Consenso concesso il:</span>
                        <span className=' text-neutral-700 text-text-sm'>{new Date(timestamp * 1000).toLocaleString('it-IT')}</span>
                    </div>
                ]
                } />
            </div>
        </div >
    )
}
